export default {
  button: {
    id: 'buyback_seo_hero_button',
    defaultMessage: 'Get trade-in offer',
  },
  upTo: {
    id: 'buyback_seo_hero_up_to',
    defaultMessage: 'Up to',
  },
  title: {
    id: 'buyback_seo_hero_title',
    defaultMessage: 'Sell {productName}',
  },
  imageAlt: {
    id: 'buyback_seo_hero_image_alt',
    defaultMessage: 'Trade-in illustration',
  },
  medal: {
    id: 'buyback_seo_hero_medal',
    defaultMessage: 'Highest offer guaranteed',
  },
  money: {
    id: 'buyback_seo_hero_money',
    defaultMessage: 'Fast cash payment',
  },
  official: {
    id: 'buyback_seo_hero_official',
    defaultMessage: 'Safe data handling',
  },
  truck: {
    id: 'buyback_seo_hero_truck',
    defaultMessage: 'Free & insured shipping',
  },
}
